package uz.mint.frontend.i18n

/**
 * The three forms a counted noun can take across the site's languages.
 *
 * Russian is the default locale and genuinely needs all three ("1 день", "2 дня", "5 дней"),
 * so a naive `if (n == 1)` would be wrong on the page most visitors land on. Languages that
 * need fewer forms just repeat themselves.
 */
data class PluralForms(val one: String, val few: String, val many: String)

/** Picks the form [count] takes in this locale. Only the noun — callers prepend the number. */
fun Locale.plural(count: Int, forms: PluralForms): String = when (this) {
    // 1, 21, 31 → one; 2-4, 22-24 → few; 5-20, 11-14 → many.
    Locale.RU -> {
        val mod10 = count % 10
        val mod100 = count % 100
        when {
            mod10 == 1 && mod100 != 11 -> forms.one
            mod10 in 2..4 && mod100 !in 12..14 -> forms.few
            else -> forms.many
        }
    }
    // Uzbek nouns do not agree with a preceding numeral: "1 kun", "7 kun".
    Locale.UZ -> forms.one
    Locale.EN -> if (count == 1) forms.one else forms.many
}
